import Base from "../base";

export default class TipoRespuestaServices extends Base {
    static endpointUrl = "encuestas/tipo_respuesta/"
}